import { useState } from 'react';

type State = {
  current: 'idle' | 'confirm' | 'success';
};

export const useRemoveMachine = () => {
  const [state, send] = useState<State>({ current: 'idle' });

  return [state, send] as const;
};
